/**
 * Global Imports
*/

import React, { useEffect, useContext } from 'react';

/**
 * Root Imports
*/

import { PageContext } from '~/components/PageProvider';
import { ShowAbilityService } from '~/services/Ability';

/**
 * Local Imports
*/

import { AbilityContext } from '../../Providers/AbilityProvider';
import { ResourceManage } from '../../Widgets/ResourceManage';

/**
 * Exports
*/

/**
 * 
 */
export function ShowAbility(props) {
  /** Contexts **/
  
  const page = useContext(PageContext);
  
  /** Side-Effects **/

  useEffect(() => {
    handleMount();
  }, []);

  /** Event Handlers **/
  
  /**
   * 
   */
  const handleMount = () => {
    page.change({
      group: 'abilities',
      breadcrumbs: ['Abilities', 'View Ability']
    });
  };
  
  /** Renderers **/

  /**
   * 
   */
  const renderResource = (resource) => (
    <div>The ability { resource.title } was created at { resource.created_at }.</div>
  );
  
  /** Output **/
  
  return (
    <ResourceManage
      group='abilities'
      context={ AbilityContext }
      service={ ShowAbilityService }
      renderResource={ renderResource }
    />
  );
}